import React from 'react';
// import { useTranslation, withTranslation, Trans } from 'react-i18next';
// import ReactDOM from 'react-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Carousel } from 'react-responsive-carousel';
// import { Nav, Navbar, NavDropdown, Form, FormControl, Button, Carousel } from 'react-bootstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// import 'bootstrap/dist/css/bootstrap.min.css';

import i18n from "../i18n";

// import Product from './Product';
// import About from './About';
// import Video from './Video';
// import Contact from './Contact';
// import ContactInput from './ContactInput';

import Home_Carousel from './Home_Carousel';
// import Home_Carousel_Responsive from './Home_Carousel_Responsive';

import { faGlobe,faHome, faPhoneSquare} from "@fortawesome/free-solid-svg-icons";
import { faLine, faFacebookSquare, faInstagramSquare, faTwitterSquare, faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import { library } from '@fortawesome/fontawesome-svg-core'
// import { fas } from "@fortawesome/free-solid-svg-icons";
// import { faCoffee } from '@fortawesome/free-solid-svg-icons'
// import WhereToBuy from './WhereToBuy';

const Page = () => (
    <div>
        <Home_Carousel />
        {/* <Home_Carousel_Responsive /> */}
        <FontAwesomeIcon size="2x" style={{marginLeft:"5px"}} color="#CACA30" icon={faPhoneSquare} rotate=""/>
        <FontAwesomeIcon size="2x" style={{marginLeft:"5px"}} color="#00c300" icon={faLine}/>
        <FontAwesomeIcon size="2x" style={{marginLeft:"5px"}} color="#3b5998" icon={faFacebookSquare}/>
        <FontAwesomeIcon size="2x" style={{marginLeft:"5px"}} color="#9b6954" icon={faInstagramSquare}/>
        <FontAwesomeIcon size="2x" style={{marginLeft:"5px"}} color="#1DA1F2" icon={faTwitterSquare}/>
        <FontAwesomeIcon size="2x" style={{marginLeft:"5px"}} color="#FF0000" icon={faYoutube}/>
        <FontAwesomeIcon size="2x" style={{marginLeft:"5px"}} color="#1DA1F2" icon={faLinkedin}/>

        {/* <FontAwesomeIcon icon={faGlobe} size="2x" />
        <FontAwesomeIcon icon={faHome} size="2x"/> */}
        <br/>

        <div className="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
            <h1 className="display-4">Pricing </h1>
            <p className="lead">Quickly build an effective pricing table for your potential customers with this Bootstrap example. It's built with default Bootstrap components and utilities with little customization.</p>
        </div>
        <div className="c-content-box c-size-md c-bg-grey-1">
            <div className="container">
                <div className="c-content-bar-1 c-opt-1">
                    <h3 className="c-font-uppercase c-font-bold">ขายที่ดินเปล่า สวยๆติดเขื่อนสิรินธร ริมน้ำ จำนวน 100 แปลง (แบ่งขาย) </h3>
                        <p className="c-font-uppercase">
                        “เขื่อนสิรินธร” นั้นนอกจากจะมีทัศนีย์ภาพของทะเลสาบเหนือสันเขื่อนที่สวยงามแล้วยังมีหย่อม จัดสวนทั้งไม้ดอก ไม้ดัด ไว้ได้อย่างสวยงาม หรือเรียกได้ว่าเป็นจุดที่น่าสนในของเขื่อนสิริธรแห่งนี้ นักท่องเที่ยวจะชอบมาถ่ายรูปกัน นั่นก็คือ “สวนสิรินธร” ซึ่งจะมีประติมากรรมช้างสามเชือก ตีระนาด สีซอและเป่าขลุ่ย และมีน้ำพุด้วย ทำให้บรรยกาศเย็นสบายตลอดเวลา และเครื่องดนตรีทั้งสามชนิดนี้เป็นเครื่องดนตรีที่สมเด็จพระเทพรัตนราช สุดาฯ สยามบรมราชกุมารีทรงโปรดปราน บรรยากาศภายใน “สวนสิรินธร” ร่มรื่นชื่นเย็นไปด้วยแมกไม้น้อยใหญ่ และทุกท่านที่ได้ผ่านเข้ามา ณ สวนแห่งนี้ก็จะใช้เป็นสถานที่นั่งพักผ่อนหย่อนใจด้วย
                    </p>
                </div>
            </div>
        </div>
        <div className="c-content-box c-size-md c-bg-white">
            <div className="container">
                <div className="c-content-feature-2-grid">
                    {/* <div className="c-content-title-1">
                        <h3 className="c-font-uppercase c-center c-font-bold">Services We Do</h3>
                        <div className="c-line-center"></div>
                    </div> */}
                    <div className="row">
                        <div className="col-md-4 col-sm-6"> <div className="c-content-feature-2 c-option-2 c-theme-bg-parent-hover"> <h3 className="c-font-uppercase c-title">บรรยากาศดี อากาศดี</h3> <p></p> </div> </div>
                        <div className="col-md-4 col-sm-6"> <div className="c-content-feature-2 c-option-2 c-theme-bg-parent-hover"> <h3 className="c-font-uppercase c-title">เหมาะทำบ้านพักตากอากาศ</h3> <p></p> </div> </div>
                        <div className="col-md-4 col-sm-6"> <div className="c-content-feature-2 c-option-2 c-theme-bg-parent-hover"> <h3 className="c-font-uppercase c-title">น้ำไม่ท่วม</h3> <p></p> </div> </div>
                        <div className="col-md-4 col-sm-6"> <div className="c-content-feature-2 c-option-2 c-theme-bg-parent-hover"> <h3 className="c-font-uppercase c-title">เอกสารเป็นโฉนดพร้อมโอนซื้อขาย</h3> <p></p> </div> </div>
                        <div className="col-md-4 col-sm-6"> <div className="c-content-feature-2 c-option-2 c-theme-bg-parent-hover"> <h3 className="c-font-uppercase c-title">เดินทางสะดวก</h3> <p></p> </div> </div>
                        <div className="col-md-4 col-sm-6"> <div className="c-content-feature-2 c-option-2 c-theme-bg-parent-hover"> <h3 className="c-font-uppercase c-title">ถนนลาดยางตลอดเส้นทาง</h3> <p></p> </div> </div>
                    </div>
                </div>
            </div> 
        </div>
            <div className="c-content-box c-size-md c-bg-white">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="c-content-feature-1" style={{textAlign: "center"}} >
                                <div className={"c-theme "+i18n.t('FEATURE.ICON')} style={{"color": i18n.t('FEATURE.ICON_COLOR')}} ></div>
                                <h3 className="c-font-uppercase c-font-bold font-billy">{i18n.t('FEATURE.TOPIC')}</h3>
                                <p className="c-font-thin ">{i18n.t('FEATURE.DESC')}</p>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="c-content-feature-1" style={{textAlign: "center"}} >
                                <div className={"c-theme "+i18n.t('FEATURE.ICON')} style={{"color": i18n.t('FEATURE.ICON_COLOR')}} ></div>
                                <h3 className="c-font-uppercase c-font-bold font-billy">{i18n.t('FEATURE.TOPIC')}</h3>
                                <p className="c-font-thin ">{i18n.t('FEATURE.DESC')}</p>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="c-content-feature-1" style={{textAlign: "center"}} >
                                <div className={"c-theme "+i18n.t('FEATURE.ICON')} style={{"color": i18n.t('FEATURE.ICON_COLOR')}} ></div>
                                <h3 className="c-font-uppercase c-font-bold font-billy">{i18n.t('FEATURE.TOPIC')}</h3>
                                <p className="c-font-thin ">{i18n.t('FEATURE.DESC')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Product/> */}
            {/* <About/> */}
            {/* <Video/> */}
            {/* <WhereToBuy/> */}
            {/* <Contact/> */}

        <div className="c-content-box c-size-md c-overflow-hide c-bs-grid-small-space c-bg-grey-1" >
            <div className="container">
                <div className="c-content-bar-1 c-opt-1">
                    <h3 className="c-font-uppercase c-font-bold ">แผนที่</h3>
                    <p className="c-font-uppercase">
                    </p>
                </div>
            </div> 
        </div>
        <div className="c-content-box c-size-md">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="c-content-blog-post-1-view">
                            <div className="c-content-blog-post-1">
                                <div className="c-media">
                                    <a href="https://goo.gl/maps/V2376ELVEo3cwXGV6"> 
                                    <LazyLoadImage
                                        className="responsive"
                                        alt="First slide"
                                        src="appDefault/1920x1080.webp"
                                        width="100%"
                                        height="100%"
                                    />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
        <div className="container">
      <div className="card-deck mb-3 text-center">
        <div className="card mb-4 box-shadow">
          <div className="card-header">
            <h4 className="my-0 font-weight-normal">Free</h4>
          </div>
          <div className="card-body">
            <h1 className="card-title pricing-card-title">$0 <small className="text-muted">/ mo</small></h1>
            <ul className="list-unstyled mt-3 mb-4">
              <li>10 users included</li>
              <li>2 GB of storage</li>
              <li>Email support</li>
              <li>Help center access</li>
            </ul>
            <button type="button" className="btn btn-lg btn-block btn-outline-primary">Sign up for free</button>
          </div>
        </div>
        <div className="card mb-4 box-shadow">
          <div className="card-header">
            <h4 className="my-0 font-weight-normal">Pro</h4>
          </div>
          <div className="card-body">
            <h1 className="card-title pricing-card-title">$15 <small className="text-muted">/ mo</small></h1>
            <ul className="list-unstyled mt-3 mb-4">
              <li>20 users included</li>
              <li>10 GB of storage</li>
              <li>Priority email support</li>
              <li>Help center access</li>
            </ul>
            <button type="button" className="btn btn-lg btn-block btn-primary">Get started</button>
          </div>
        </div>
        <div className="card mb-4 box-shadow">
          <div className="card-header">
            <h4 className="my-0 font-weight-normal">Enterprise</h4>
          </div>
          <div className="card-body">
            <h1 className="card-title pricing-card-title">$29 <small className="text-muted">/ mo</small></h1>
            <ul className="list-unstyled mt-3 mb-4">
              <li>30 users included</li>
              <li>15 GB of storage</li>
              <li>Phone and email support</li>
              <li>Help center access</li>
            </ul>
            <button type="button" className="btn btn-lg btn-block btn-primary">Contact us</button>
          </div>
        </div>
      </div>

      
      </div>
      
      {/* <ContactInput/> */}
    </div>
)
export default Page  